export default __webpack_public_path__ + "static/media/doctor5.cddc949a.jpg";